<!DOCTYPE html>
<html>

<head>
    <style>
        /* Container for the iframe */
        .iframe-container {
            position: relative;
            width: 800px;
            height: 800px;
        }

        /* Close button style */
        .close-button {
            position: absolute;
            top: 10px;
            right: 10px;
            background-color: red;
            color: white;
            border: none;
            padding: 10px;
            cursor: pointer;
            font-size: 16px;
        }
    </style>
</head>

<body>

    <div *ngIf="isIframeVisible" class="iframe-container">
        <!-- Close button -->
        <button class="close-button" (click)="closeIframe()">X</button>

        <!-- Iframe with sanitized src URL -->
        <iframe [src]="iframeSrc" height="800" width="800" title="Iframe Example"></iframe>
    </div>


</body>

</html>